import React from "react";
import { SSH_ImageViewer } from "../../../components/molecules/ImageViewer/ImageViewer.component";
import S from "./AuthorBlock.module.scss";

interface SSH_AuthorBlockProps {
    authorImageUrl?: string;
    authorImageName?: string;
    authorName?: string;
    authorTitle?: string;
    authorDate?: string;
}

export const SSH_AuthorBlock = ({ ...props }: SSH_AuthorBlockProps) => {
    return (
        <div className={S.author}>
            {props?.authorImageUrl && (
                <div className={S.authorImage}>
                    <div className={S.authorImageItem}>
                        <SSH_ImageViewer
                            src={props?.authorImageUrl}
                            aspectRatioX={1}
                            aspectRatioY={1}
                            alternative={props?.authorImageName}
                            forceWidth={200}
                        />
                    </div>
                </div>
            )}

            <div className={S.authorInfo}>
                {props?.authorName && <span className={S.authorInfoName}>{props?.authorName}</span>}
                {props?.authorTitle && (
                    <span className={S.authorInfoTitle}>{props?.authorTitle}</span>
                )}
            </div>
            {props.authorDate && <div className={S.authorDate}>{props.authorDate}</div>}
        </div>
    );
};
